import React, { useState } from "react";
import * as yup from "yup";
import { RequestCategorySubCategory } from "types/CivilTypes";
import {
  Form,
  Panel,
  Button,
  DataTable,
  DataTableColumn,
  Checkbox,
  HelpIconMode,
} from "@countysuite/ui";
import { getSelectedRows } from "../getSelectedRows";
import { HelpIconButton } from "components/HelpIconButton/HelpIconButton";

export interface Props {
  caseCategories: RequestCategorySubCategory[];
  selectedIDs: string[];
  onChangeSelectedIDs: (selections: string[]) => void;
  onSave: () => Promise<boolean>;
  nextStep: () => void;
}

export const LackOfProsecutionCaseCategoriesPanel: React.FC<Props> = (
  props
) => {
  const [onlySelected, setOnlySelected] = useState(false);

  let tableData: RequestCategorySubCategory[];
  if (onlySelected) {
    tableData = getSelectedRows(
      props.selectedIDs,
      props.caseCategories,
      (caseCategory: RequestCategorySubCategory) => caseCategory.id
    );
  } else {
    tableData = props.caseCategories;
  }

  const columns: DataTableColumn<RequestCategorySubCategory>[] = [
    {
      Header: () => <div style={{ textAlign: "left" }}>Case Category</div>,
      id: "caseCategoryNameCol",
      accessor: (row) => row.name,
      width: 300,
    },
  ];

  const atLeastOne = yup
    .array()
    .min(1, "Please select at least one case category.");

  async function handleSubmit() {
    const success = await props.onSave();
    if (success) {
      props.nextStep();
    }
  }

  return (
    <Form
      onSubmit={handleSubmit}
      values={props.selectedIDs}
      validationSchema={atLeastOne}
    >
      {(formProps) => (
        <Panel
          title="Case Categories that are Included"
          buttons={
            <>
              <HelpIconButton mode={HelpIconMode.Modal}>
                {props.children}
              </HelpIconButton>
              <Button color="success" onClick={formProps.handleSubmit}>
                Save
              </Button>
            </>
          }
        >
          <Checkbox
            name="onlySelectedCaseCategories"
            checked={onlySelected}
            onChange={(e: any) => setOnlySelected(e.target.checked)}
          >
            Only show selected rows
          </Checkbox>
          <DataTable
            id="caseCategoriesSelectTable"
            keyField="id"
            selectedKeys={props.selectedIDs}
            onChangeSelections={props.onChangeSelectedIDs}
            data={tableData}
            columns={columns}
            ignoreSymbolsWhenFiltering
            filterOn={["name"]}
          />
        </Panel>
      )}
    </Form>
  );
};

(LackOfProsecutionCaseCategoriesPanel as any).displayName =
  "LackOfProsecutionCaseCategoriesPanel";
